/**
 * Converts a string value to a boolean.
 *
 * @param value - The string value to convert. If the value is `null` or `undefined`, it returns `false`.
 * @returns `true` if the string is not 'false' (case insensitive), otherwise `false`.
 */
export function stringToBoolean(value?: string | null): boolean {
    if (!value) {
        return false;
    }
    return value.toLowerCase() !== 'false';
}
